<template>
    <div class="flex overflow-hidden rounded h-full">
        <!-- Poster -->
        <div class="relative flex-shrink-0 w-28 sm:w-36">
            <img
                v-if="imaged"
                :ref="`img-${movie.id}`"
                class="box-art w-full object-cover opacity-0"
                :src="image"
                :alt="movie.title"
                @error="setImaged()"
                @load="imageIn()"
                :key="movie.id"
            />
            <div v-if="!imaged" class="w-full h-full bg-slate-800 flex items-center justify-center p-2">
                <span class="text-xs text-amber-200 text-center leading-tight">{{ movie.title }}</span>
            </div>
            <!-- Status badge -->
            <div class="absolute top-2 left-0 right-0 flex justify-center">
                <span class="bg-black/70 backdrop-blur-sm text-xs px-2 py-0.5 rounded-full font-medium uppercase tracking-wide"
                    :class="movie.status === 'released' ? 'text-slate-300' : 'text-green-400'">
                    {{ convertStatus(movie.status) }}
                </span>
            </div>
        </div>

        <!-- Info -->
        <div class="flex flex-col flex-1 min-w-0 px-3 pt-0">
            <div class="flex-1">
                <div class="flex items-start justify-between gap-2 mb-1">
                    <h2 class="text-lg font-bold text-secondary-light leading-tight">{{ movie.title }}</h2>
                    <span class="text-sm text-amber-300 shrink-0 mt-0.5">{{ movie.year }}</span>
                </div>
                <div class="flex items-center gap-2 mb-2">
                    <span class="text-sm text-amber-400">{{ formatDate(movie.release_date, 'MMM D, YYYY') }}</span>
                    <span v-if="movie.genres" class="text-xs text-amber-300">· {{ movie.genres }}</span>
                </div>
                <p v-if="movie.overview" class="text-base text-amber-300 leading-relaxed" :title="movie.overview">
                    {{ truncateWords(movie.overview, 25) }}
                </p>
            </div>

            <!-- Footer metadata -->
            <div class="mt-3 pt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-amber-500">
                <span v-if="movie.studio">{{ movie.studio }}</span>
                <a v-if="movie.website?.length" :href="movie.website" rel="nofollow" class="text-amber-400 hover:text-amber-200">Website</a>
                <a v-if="movie.youtube_trailer_id" :href="`https://youtube.com/watch?v=${movie.youtube_trailer_id}`" rel="nofollow" class="text-amber-400 hover:text-amber-200">Trailer</a>
            </div>
        </div>
    </div>
</template>

<script>
import { convertStatus, formatDate, truncateWords } from '@/utils/Utilities';
import { gsap } from 'gsap/all'

export default {
    name: 'MovieBox',
    props: ['movie', 'image'],
    data() {
        return {
            imaged: true
        }
    },
    methods: {
        convertStatus,
        formatDate,
        truncateWords,
        imageIn() {
            gsap.fromTo(this.$refs[`img-${this.movie.id}`],
                { scale: .98, y: 10, opacity: 0 },
                { y: 0, scale: 1, opacity: 1, duration: .8, ease: "power3.out" }
            )
        },
        setImaged() {
            setTimeout(() => { this.imaged = false }, 250)
        }
    }
}
</script>
